import { CheckCircleOutlined } from '@ant-design/icons';
import { Image } from 'antd';
import React from 'react';
import Item from './Item';

const Sickness = ({ passport }) => {
  return (
    <>
      {passport.health.file ? <Item label={`File Kesehatan`} value={(
        <>
          {passport.health.is_image ? <Image height={100} width={100} src={passport.health.file_url} /> : <a href={passport.health.file_url}>Download File</a>}
        </>
      )} /> : <Item label="File Kesehatan" value="Belum diunggah"/>}
      <Item label={`Riwayat Kesehatan`} value={<List sickness={passport.sickness}/>} />
    </>
  );
}

export default Sickness;

const List = ({ sickness }) => {
  return sickness.length > 0 ? (
    <>
      {sickness.map((sick, key) => {
        return <div className="gx-mb-2" key={`sick-item-${key}`}>
        <CheckCircleOutlined /> {sick.label}
      </div>;
      })}
    </>
  ) : "Tidak ada riwayat kesehatan dipilih";
}